import { findRecursive } from '@/mm/utils.js'

export function washData_productImgText1(walkedNode) {
  console.log('washData_productImgText1');
  
  const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_1', 'list')
  if (ProNode) {
    if (!ProNode?.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode?.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode?.actions.find((item) => item === 'translate')) {
      ProNode?.actions.push('translate')
    }
  }

  // 一行两列
  const rowColNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'rowCol',
    'list'
  )

  if (rowColNode) {
    if (!rowColNode.actions.includes('hover')) {
      rowColNode.actions = ['design', 'hover', 'animate', 'isShow']
    }
  }
}
